<template>
  <f7-page
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore"
    @tab:init="onPageInit"
  >
    <f7-list
      medial-list
      virtual-list
      :virtual-list-params="{
        height: theme.ios ? 63 : theme.md ? 73 : 77,
      }"
      class="orderlist"
    >
      <template v-for="(item, index) in list" :key="index">
        <f7-list-item
          :title="
            formatDate(item.ShippingDate) +
            ' ' +
            item.ShippingTime.StartTime +
            '~' +
            item.ShippingTime.EndTime
          "
          :footer="'订单号：' + item.OrderNo"
          class="shang"
          ><template #inner-end
            ><span class="deliverRed">Tot:${{ item.AllTotal }}</span>
            <div :class="'deliverType dt' + item.DeliverType">
              {{ item.DeliverType == 1 ? "自送" : "车队" }}
            </div>
          </template></f7-list-item
        >
        <f7-list-item
          media-item
          :checkbox="listcheckbox"
          :value="item.Id"
          :virtual-list-index="item.index"
          @change="onMovieChange"
          class="zhong"
        >
          <template #header>
            <div class="imain">
              <div class="l">
                <f7-row no-gap>
                  <f7-col width="70" class="orderno">
                    <f7-badge color="orange"> No.{{ item.TakeNo }} </f7-badge>
                  </f7-col>
                  <f7-col width="30">
                    <div :class="'status st' + item.Status">
                      {{ $t("Order.StatusList." + item.Status) }}
                    </div>
                  </f7-col>
                </f7-row>
                <f7-row no-gap>
                  <f7-col
                    >订单合计：<span class="text_red"
                      >${{ item.Total }}</span
                    ></f7-col
                  >
                  <f7-col
                    >运费收入：<span class="text_red"
                      >${{ item.Freight }}</span
                    ></f7-col
                  >
                </f7-row>
                <f7-row no-gap v-if="ShopMode==2">
                  <f7-col
                    >GST：<span class="text_red">{{ item.Gst }}</span></f7-col
                  >
                  <f7-col
                    >取餐时间：<span class="quchan">{{
                      item.TakeFoodTime
                    }}</span></f7-col
                  >
                </f7-row>
                <f7-row no-gap>
                  <f7-col>联系人：{{ item.Consignee }}</f7-col>
                  <f7-col
                    ><span class="quchan">{{ item.Phone }}</span></f7-col
                  >
                </f7-row>
                <div class="zipCode">邮编：{{ item.ZipCode }}</div>
                <div class="address">地址：{{ item.Address }}</div>
                <div v-if="item.Remark" class="orderremark">
                  备注：{{ item.Remark }}
                </div>
              </div>
              <div class="r">
                <f7-button
                  raised
                  fill
                  color="red"
                  v-if="Status == 1"
                  @click="affirmReceipt(item.Id)"
                  ><p>确认 接单</p></f7-button
                ><f7-button
                  raised
                  fill
                  color="blue"
                  v-if="Status == 3 && item.DeliverType == 1"
                  @click="affirmDelivery(item.Id)"
                  ><p>确认 送达</p></f7-button
                >
              </div>
            </div>
          </template>
        </f7-list-item>
        <f7-list-item accordion-item after="点击展开"
          ><template #title><span class="text_blue">详情</span></template
          ><f7-accordion-content>
            <f7-list media-list class="olist">
              <f7-list-item title="餐具份数" v-if="ShopMode==2">
                <template #after
                  ><span class="text_blue">{{
                    item.Tableware == 0
                      ? "无需餐具"
                      : item.Tableware == 11
                      ? "10份以上"
                      : item.Tableware + "份"
                  }}</span></template
                >
              </f7-list-item>
              <f7-list-item v-if="item.ShopRemark" :title="item.ShopRemark">
              </f7-list-item>
              <f7-list-item v-if="item.Exchange" :title="item.Exchange">
              </f7-list-item>
              <f7-list-item v-if="item.TourDiyAward" :title="item.TourDiyAward">
              </f7-list-item>
              <f7-list-item
                v-if="item.FirstDerateName"
                :title="item.FirstDerateName"
              >
              </f7-list-item>
              <f7-list-item v-if="item.DerateName" :title="item.DerateName">
              </f7-list-item>
              <f7-list-item
                v-for="(items, indexs) in item.OrderItem"
                :key="indexs"
                ><template #title>
                  {{ $field(items.Name) }}
                  <span class="text_blue"> × {{ items.Number }}</span>
                </template>
                <template #after>
                  <span class="text_red">$ {{ items.Total }}</span>
                </template>
                <div
                  class="specItem"
                  v-for="itemss in items.ProductSpec"
                  :key="itemss.Id"
                >
                  {{ $field(itemss.Name) }}
                </div>
              </f7-list-item>
            </f7-list>
          </f7-accordion-content></f7-list-item
        >
        <section class="cutoff"></section>
      </template>
    </f7-list>
    <div class="nomore" v-if="list.length == 0">没有更多记录</div>
    <f7-toolbar bottom>
      <f7-button
        class="toolbut"
        color="white"
        outline
        @click="exportChange()"
        v-if="!listcheckbox"
        >批量导出</f7-button
      >
      <div class="botbuts">
        <div class="buts">
          <f7-segmented tag="p">
            <f7-button
              fill
              color="red"
              outline
              @click="exportData()"
              v-if="listcheckbox & (butMode == 1)"
            >
              确认导出</f7-button
            ><f7-button
              fill
              color="deeporange"
              outline
              @click="cancelExport()"
              v-if="listcheckbox"
              active
              >取消</f7-button
            >
          </f7-segmented>
        </div>
      </div>
    </f7-toolbar>
  </f7-page>
</template>
<script>
import util from "util/date";
import store from "../js/store";
import {
  getShopOrderList,
  orderAllExportData,
  orderAffirmReceipt,
  orderAffirmDelivery,
} from "@/api/api";
import { theme, f7 } from "framework7-vue";
export default {
  props: {
    f7route: Object,
  },
  data() {
    return {
      theme,
      allowInfinite: true,
      showPreloader: false,
      list: [],
      total: 0,
      page: 1,
      listcheckbox: false,
      butMode: 1,
      selectIds: [],
      Status: 1,
      Mode: 1,
    };
  },
  methods: {
    exportChange() {
      this.listcheckbox = true;
      this.butMode = 1;
    },
    affirmChange() {
      this.listcheckbox = true;
      this.butMode = 2;
    },
    cancelExport() {
      this.listcheckbox = false;
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    onMovieChange: function (e) {
      var self = this;
      var value = e.target.value;
      var selectIds = self.selectIds;
      if (e.target.checked) {
        selectIds.push(Number(value));
      } else {
        selectIds.splice(selectIds.indexOf(Number(value)), 1);
      }
    },
    affirmDelivery(orderId) {
      f7.dialog.confirm("您确定商品已送到了吗？", "提示", () => {
        let para = {
          orderId,
        };
        orderAffirmDelivery(para).then((res) => {
          if (util.isEmt.format(res)) {
            return;
          }
          if (res.data.success) {
            this.getList(true);
            f7.toast
              .create({
                icon: '<i class="f7-icons">checkmark_alt</i>',
                text: res.data.msg,
                position: "center",
                closeTimeout: 2000,
              })
              .open();
          } else {
            f7.toast
              .create({
                icon: '<i class="f7-icons">multiply</i>',
                text: res.data.msg,
                position: "center",
                closeTimeout: 2000,
              })
              .open();
          }
        });
      });
    },
    affirmReceipt(orderId) {
      f7.dialog.confirm(
        "确认后请务必提前准备好订单，司机会在派送时间的半小时前取餐！如有缺货请直接电话联系顾客换菜，若产生退款相关事宜，请告知KOIPY工作人员或客服Ｋ妹。",
        "提示",
        () => {
          let para = {
            orderId,
          };
          orderAffirmReceipt(para).then((res) => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.getList(true);
              f7.toast
                .create({
                  icon: '<i class="f7-icons">checkmark_alt</i>',
                  text: res.data.msg,
                  position: "center",
                  closeTimeout: 2000,
                })
                .open();
            } else {
              f7.toast
                .create({
                  icon: '<i class="f7-icons">multiply</i>',
                  text: res.data.msg,
                  position: "center",
                  closeTimeout: 2000,
                })
                .open();
            }
          });
        }
      );
    },
    exportData() {
      if (this.selectIds.length <= 0) {
        f7.toast
          .create({
            icon: '<i class="f7-icons">multiply</i>',
            text: "请选择信息",
            position: "center",
            closeTimeout: 2000,
          })
          .open();
        return;
      }
      f7.dialog.confirm(
        "如果无法下载，请复制链接到其他浏览器下载，微信内无法下载",
        "提示",
        () => {
          let para = {
            key: this.f7route.params.shopId,
            ids: this.selectIds,
          };
          orderAllExportData(para).then((res) => {
            var filename = res.headers; //下载后文件名
            filename = filename["content-disposition"];
            filename = filename.split(";")[1].split("filename=")[1];
            const link = document.createElement("a");
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            link.style.display = "none";
            link.className = "external";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURIComponent(filename));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.listcheckbox = false;
          });
        }
      );
    },
    loadMore() {
      const self = this;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;

      self.showPreloader = true;
      self.getList();
    },
    //获取列表
    getList(isload = false) {
      const self = this;
      if (isload) {
        f7.preloader.show();
        self.page = 1;
        self.list = [];
      }
      let para = {
        page: this.page,
        status: this.Status,
        key: this.f7route.params.shopId,
      };
      getShopOrderList(para).then((res) => {
        self.list = this.list.concat(res.data.response.data);
        f7.preloader.hide();
        self.showPreloader = false;
        if (res.data.response.data.length > 0) {
          self.page++;
          self.allowInfinite = true;
        }
      });
    },
    onPageInit() {
      this.Status = this.f7route.params.status ? this.f7route.params.status : 1;
      this.ShopMode = parseInt(window.localStorage.ShopMode) ;
      this.getList(true);
    },
  },
};
</script>
<style scoped>
.orderinfo {
  padding-top: 10px;
}
.infocss {
  font-size: 13px;
}
.infocss .no {
  font-size: 13px;
  color: #2196f3;
  margin-bottom: 5px;
}
.orderlist .cutoff {
  height: 10px;
  background: #efeff4;
}
.orderlist ul section:last-child {
  display: none;
}
.orderlist .col {
  line-height: 16px;
}
.status {
  line-height: 24px;
  margin: 2px;
  text-align: center;
  color: #fff;
  border-radius: 14px;
}

.st101 {
  background-color: mediumblue !important;
}
.st102,
.st201 {
  background-color: orange !important;
}
.st202,
.st203,
.st204 {
  background-color: lightcoral !important;
}

.st300 {
  background-color: limegreen !important;
}

.st401 {
  background-color: darkgray !important;
}

.st402 {
  background-color: tomato !important;
}

.st403 {
  background-color: darkgray !important;
}

.botbar {
  display: flex;
  align-items: center;
  font-size: 13px;
}
.botbar label {
  margin-right: 10px;
}
.botbuts {
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.buts {
  width: 50%;
  display: inline-block;
}
.toolbut {
  padding: 0 20px;
}
.date {
  font-weight: bold;
}
.specItem {
  display: inline-block;
  background-color: #f1f2f4;
  border-radius: 3px;
  padding: 2px 5px;
  font-size: 14px;
  margin: 4px 4px;
  color: #666;
}
.orderremark {
  margin-top: 5px;
  font-size: 14px;
  color: #2196f3;
}
.quchan {
  color: #2196f3;
  font-weight: bold;
}
.orderno {
  line-height: 24px;
}
.zipCode,
.address {
  line-height: 16px;
}

.deliverType {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  letter-spacing: 4px;
  color: #fff;
  margin: 0 auto;
  writing-mode: vertical-lr;
  padding: 5px;
}

.deliverRed {
  color: #ff3b30;
  padding-right: 20px;
  font-size: 16px;
}
.dt2 {
  background-color: #009688;
}
.dt1 {
  background-color: #2196f3;
}
.imain {
  display: flex;
}
.imain .l {
  width: calc(100% - 50px);
}
.imain .r {
  width: 50px;
  display: flex;
  align-items: center;
}
.imain .r .button {
  white-space: pre-line;
  line-height: 20px;
  height: 45px;
}
.imain .r .button p {
  margin: 0;
}
</style>
<style >
.zhong .item-inner {
  padding-top: 3px;
  padding-right: 10px;
}
.shang .item-inner {
  padding-bottom: 3px;
  overflow: hidden;
}
.shang .item-title {
  font-weight: bold;
}
</style>